module.exports = __webpack_public_path__ + "img/caidm.a50fd81b.png";